import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=2ec63564&scoped=true&"
import script from "./Certification.vue?vue&type=script&lang=js&"
export * from "./Certification.vue?vue&type=script&lang=js&"
import style0 from "./Certification.vue?vue&type=style&index=0&id=2ec63564&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec63564",
  null
  
)

export default component.exports